import { of } from 'rxjs';
import { ComponentDataSourceService } from '../component-data-source.service';
import { DualPanelItem } from '../../../interfaces/DualPanelItem.interface';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';

export function dual_panel_roles(componentDataSourceService: ComponentDataSourceService) {
    return {
        name: 'Dual Panel Roles',
        description: 'Lists all available roles in a format suitable for dual panel selector',
        execute: (params?: LoadDataParams) => {
            
            // Static list of roles
            const roles: DualPanelItem[] = [
                { value: 'superadmin', name: 'Superadmin', type: 'system' },
                { value: 'orgadmin', name: 'Orgadmin', type: 'organization' },
                { value: 'orguser', name: 'Orguser', type: 'organization' },
                { value: 'bruger', name: 'Bruger', type: 'education' },
                { value: 'oevrig', name: 'Oevrig', type: 'education' },
            ];

            return of({
                data: roles
            });
        }
    };
} 